import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResidentDocMoveComponent } from './components/resident-doc-move/resident-doc-move.component';
import { StartDocTransferComponent } from './components/start-doc-transfer/start-doc-transfer.component';
import { ConversionsFeatureRoutingModule } from './conversions-feature-routing.module';
import {ConversionsFeatureComponent} from './conversions-feature.component';
import {ConversionsResidentDocMoveGuard} from './services/conversions-resident-doc-move-guard';
import { DetailDocTransferComponent } from './components/detail-doc-transfer/detail-doc-transfer.component';
import { StartDetailDocTransferComponent } from './components/start-detail-doc-transfer/start-detail-doc-transfer.component';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {ConversionsReferenceDataService} from './services/conversions-reference-data.service';
import {Select2Module} from '../shared/Select2Module';
import { ProfileSyncListComponent } from './components/profile-sync/profile-sync-list/profile-sync-list.component';
import { ProfileSyncRunComponent } from './components/profile-sync/profile-sync-run/profile-sync-run.component';
import { ProfileSyncConfirmationDialogComponent } from './components/profile-sync/profile-sync-confirmation-dialog/profile-sync-confirmation-dialog.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfileSyncFailedUsersComponent } from './components/profile-sync/profile-sync-failed-users/profile-sync-failed-users.component';
import { TreeviewModule } from '@laijuthomas/ngx-treeview';
import { CollapsibleGroupComponent } from '../shared/collapsible-group/collapsible-group.component';
import { SharedModule } from '../shared/shared.module';
import { ProcessListComponent } from './components/process-list/process-list.component';
import { SnfLegacyListComponent } from './components/snf-legacy-user-import/snf-legacy-list/snf-legacy-list.component';
import { SngLegacyImportConfirmationDialogComponent } from './components/snf-legacy-user-import/sng-legacy-import-confirmation/sng-legacy-import-confirmation-dialog.component';
import { SnfLegacyUserImportListComponent } from './components/snf-legacy-user-import/snf-legacy-user-import-list/snf-legacy-user-import-list.component';
import { SnfLegacyUserImportFailedComponent } from './components/snf-legacy-user-import/snf-legacy-user-import-failed/snf-legacy-user-import-failed.component';
import { ProcessFailedUsersComponent } from './components/process-failed-users/process-failed-users.component';
import { KeycloakUserImportListComponent } from './components/keycloak-user-import/keycloak-user-import-list/keycloak-user-import-list.component';
import { KeycloakListComponent } from './components/keycloak-user-import/keycloak-list/keycloak-list.component';
import { KeycloakUserImportFailedComponent } from './components/keycloak-user-import/keycloak-user-import-failed/keycloak-user-import-failed.component';
import { KeycloakImportConfirmationDialogComponent } from './components/keycloak-user-import/keycloak-import-confirmation-dialog/keycloak-import-confirmation-dialog.component';
import { ImportUsersListComponent } from './components/import-users-to-idm/import-users-list/import-users-list.component';
import { ImportListComponent } from './components/import-users-to-idm/import-list/import-list.component';
import { ImportUserFailedComponent } from './components/import-users-to-idm/import-user-failed/import-user-failed.component';
import { ImportConfirmationDialogComponent } from './components/import-users-to-idm/import-confirmation-dialog/import-confirmation-dialog.component'
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';



@NgModule({
  imports: [
    CommonModule,
    ConversionsFeatureRoutingModule,
    ReactiveFormsModule,
    Select2Module,
    NgxBootstrapMultiselectModule,
    FormsModule,
    NgbModule,
    TreeviewModule.forRoot(),
    SharedModule

  ],
  declarations: [
    ConversionsFeatureComponent,
    ResidentDocMoveComponent,
    StartDocTransferComponent,
    DetailDocTransferComponent,
    StartDetailDocTransferComponent,
    ProfileSyncListComponent,
    ProfileSyncRunComponent,
    ProfileSyncConfirmationDialogComponent,
    ProfileSyncFailedUsersComponent,
    SnfLegacyListComponent,
    SngLegacyImportConfirmationDialogComponent,
    ProcessListComponent,
    SnfLegacyUserImportListComponent,
    SnfLegacyUserImportFailedComponent,
    ProcessFailedUsersComponent,
    KeycloakUserImportListComponent,
    KeycloakListComponent,
    KeycloakUserImportFailedComponent,
    KeycloakImportConfirmationDialogComponent,
    ImportUsersListComponent,
    ImportListComponent,
    ImportUserFailedComponent,
    ImportConfirmationDialogComponent
  ],
  providers: [
    ConversionsResidentDocMoveGuard
  ]
})
export class ConversionsFeatureModule { }
